import axios from "axios"
import Swal from "sweetalert2"
import _Util from '../helper/_Util'
import { message } from 'antd';

const URI_API = process.env.REACT_APP_URL_API

const search = async () =>{
    try {
        let result = await axios.get(`${URI_API}/mgt-user/search`, {withCredentials: true})
        return result.data.data
      }catch(err){
        
        _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
        return []
      }
}

const getDetail = async (userId) =>{
  try {
      let result = await axios.get(`${URI_API}/mgt-user/detail/${userId}`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return false
      }
    }catch(err){
      
      _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const create = async (data) =>{
  try {
      let result = await axios.post(`${URI_API}/mgt-user/create/`, data,{withCredentials: true})
      if(result.data.status){
        Swal.fire({
          title: "ลงทะเบียนผู้ใช้งานสำเร็จ",
          icon: "success",
          timer: 2000
        })
        return result.data.data
      }else{
        Swal.fire({
          icon: 'error',
          title: result.data.msg,
          confirmButtonText: "ปิด",
          timer: 3000
        })
        return false
      }
    }catch(err){
      
      _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const update = async (userId, data) =>{
  try {
      let result = await axios.put(`${URI_API}/mgt-user/${userId}`, data,{withCredentials: true})
      if(result.data.status){
        Swal.fire({
          title: "อัพเดทบัญชีสำเร็จ",
          icon: "success",
          timer: 2000
        })
        return result.data.data
      }else{
        Swal.fire({
          icon: 'error',
          title: result.data.msg,
          confirmButtonText: "ปิด",
          timer: 3000
        })
        return false
      }
    }catch(err){
      

_Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const updateApprove= async (userId, data) =>{
  try {
      let result = await axios.put(`${URI_API}/mgt-user/approve/${userId}`, {isApprove: data}, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return false
      }
    }catch(err){
      

_Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const deleteUser = async (userId) =>{
  try {
      let result = await axios.delete(`${URI_API}/mgt-user/${userId}`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return false
      }
    }catch(err){
      

_Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const exports = {
  search: search,
  getDetail : getDetail,
  create : create,
  update: update,
  updateApprove: updateApprove,
  delete: deleteUser
}

export default exports